import {message} from 'antd';
import {getApi} from './request.js';
import {getGoogleLang} from '@/services/userApi';

const getLocalKey = () => {
    const lang = localStorage.getItem('umi_locale');
    return `${lang}-google-lang`;
};

export const locale = localStorage.getItem('umi_locale') || 'en-US';

export const getLocalImage = (imgName: string) => require(`@/assets/${locale}/${imgName}`);

export const copyLink = async (link: string) => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(link);
            message.success('复制成功');
        } else {
            // 降级方案
            const textArea = document.createElement('textarea');
            textArea.value = link;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            message.success('复制成功');
        }
    } catch (error) {
        console.error('复制链接时出错:' , error);
        message.error('复制失败，请手动复制');
    }
};

export const getQuery = () => {
    const queryParams = new URLSearchParams(location.search);
    const queryObj = Object.fromEntries(queryParams.entries());
    return queryObj;
};

export const getLocalItem = (key) => {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : '';
};

export const setLocalItem = (key , data) => {
    localStorage.setItem(key , JSON.stringify(data));
};

const filterLangs = (keys , langs) => {
    const data = {};
    keys.map((item) => {
        if (langs[item]) {
            data[item] = langs[item];
        }
    });
    return data;
};

export const getLang = async ({keys , ...rest}) => {
    // string 'title',arr:['title','desc'];
    const googleLocalKey = getLocalKey();
    if (!keys) {
        return '';
    }

    const localLang = getLocalItem(googleLocalKey);
    //过滤最简单的格式
    if (localLang?.[keys]) {
        return localLang[keys];
    }
    let text = {} , oldData = {};
    //如果是批量翻译
    if (Array.isArray(keys)) {
        //筛选出 本地没有的字段进行请求
        const newkeys = keys.filter((item) => item && !localLang?.[item]);
        if (newkeys.length < 1) {
            return filterLangs(keys , localLang);
        }
        newkeys.map((item) => {
            text[item] = item
        }); //组合请求的text格式为{key:value}；
    } else {
        text = keys;
    }

    //如果没有新字段请求返回本地数据
    if (!text || Object.keys(text).length < 1) {
        return filterLangs(keys , localLang);
    }
    //如果翻译的是简体中文 === 没翻译
    const lang = localStorage.getItem('umi_locale');
    if (lang === 'zh-CN') {
        const newData = {...localLang , ...text};
        setLocalItem(googleLocalKey , newData);
        return filterLangs(keys , newData);
    }

    try {
        const googleLang = await getLangFromGoogle({text , ...rest});
        return filterLangs(keys , googleLang);
    } catch (error) {
        console.error('获取翻译内容失败:' , error);
        message.error('翻译服务暂时不可用');
        return filterLangs(keys , localLang || {});
    }
};

export const getLangFromGoogle = async ({text = {} , source = 'zh-CN' , platform = 1}) => {
    const googleLocalKey = getLocalKey();
    const localLang = getLocalItem(googleLocalKey);

    try {
        const data = await getApi({api: getGoogleLang , params: {platform , text , source}});
        const translatedText = typeof text === 'string' ? {[text]: data} : data;

        const newJsonStr = JSON.stringify({...localLang , ...translatedText});
        const newLang = JSON.parse(newJsonStr);
        setLocalItem(googleLocalKey , newLang);
        return newLang;
    } catch (error) {
        console.error('调用谷歌翻译API失败:' , error);
        message.error('翻译服务暂时不可用');
        return localLang || {};
    }
};

export const IMAGE_BASE_URL =process.env.NODE_ENV === 'production'?'https://findtrader.net/':'http://47.236.134.12/';